import React, { useEffect, useState } from 'react';

export const Toaster = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        const handleToast = (event) => {
            const detail = event.detail || {};
            const id = `toast-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
            setItems((current) => [
                ...current.slice(-3),
                {
                    id,
                    title: detail.title || 'Notificacao REACTA',
                    message: detail.message || '',
                    type: detail.type || 'info',
                },
            ]);
            window.setTimeout(() => {
                setItems((current) => current.filter((item) => item.id !== id));
            }, Number(detail.durationMs) || 4200);
        };
        window.addEventListener('reacta:toast', handleToast);
        return () => window.removeEventListener('reacta:toast', handleToast);
    }, []);

    return (
        <div id="reacta-toaster-container" className="fixed bottom-4 right-4 z-[9999] pointer-events-none flex max-w-sm flex-col gap-2">
            {items.map((item) => (
                <section
                    key={item.id}
                    className={`rounded-l-md rounded-r-[1.75rem] border px-4 py-3 text-xs shadow-[0_0_24px_rgba(34,211,238,0.22)] backdrop-blur-md ${item.type === 'chat-direct'
                        ? 'border-amber-300/70 bg-amber-950/90 text-amber-50'
                        : 'border-cyan-300/55 bg-slate-950/95 text-cyan-50'}`}
                    role="status"
                    aria-live="polite"
                >
                    <p className="font-black uppercase tracking-[0.16em]">{item.title}</p>
                    {item.message ? <p className="mt-1 text-[11px] text-slate-200">{item.message}</p> : null}
                </section>
            ))}
        </div>
    );
};

export default Toaster;
